const NewCust = () => import('@/views/main/custIdentity/newCust/NewCust.vue')
export default {
  path: '/main/custIdentity/newCust',
  name: 'newCust',
  component: NewCust
}
